module.exports = "\n<div class=\"\">\n    <div >\n        <div  id=\"login-container\" *ngIf=\"!isAuthenticated\"></div>\n        <!-- <p *ngIf=\"isAuthenticated\">\n            <button class=\"btn btn-primary btn-raised\" type=\"button\" (click)=\"logout()\">Logout</button>            \n        </p>  -->\n    </div>\n</div>   "


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/public/login/login.component.html
// module id = ../../../../../src/app/public/login/login.component.html
// module chunks = 10